import React, { useContext, useState } from 'react'
import Layout from 'shared/layouts/Main'
import { Button, Form } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { roles } from 'consts'
import hasAnyRole from 'shared/utils/hasAnyRole'
import HeaderCustomerSelect from 'containers/HeaderCustomerSelect'
import InputWrapper from 'shared/components/InputWrapper'
import resSettings from './resolvers/resSettings'
import useInit from './hooks/useInit'
import useFocusError from 'shared/hooks/useFocusError'
import submitForm from './utils/submitForm'
import SelectWrapper from 'shared/components/SelectWrapper'
import getBrandContent from 'utils/getBrandContent'
import Footer from 'shared/components/Footer'
import prepareSubmitForm from './utils/prepareSubmitForm'
import { pageSizes } from 'consts'
import { ReactReduxContext } from 'react-redux'
import LayoutSwitcher from 'components/LayoutSwitcher'
import HeaderFilterRoleSelect from 'containers/HeaderFilterRoleSelect'

const Settings: React.FunctionComponent = () => {
  const [showOverlay, setShowOverlay] = useState<boolean>(true)
  const [dataLoaded, setDataLoaded] = useState<boolean>(false)

  const submitRef = React.createRef<HTMLButtonElement>()

  const [pageSizesObj, setPageSizesObj] = useState<any>([])
  const [defaultPageSizeObj, setDefaultPageSizeObj] = useState<any>(null)
  const [currentCustomer, setCurrentCustomer] = useState<{} | null>({})
  const [filterRole, setCurrentFilterRole] = useState<{} | null>({})

  const { store } = useContext(ReactReduxContext)

  const {
    control,
    handleSubmit,
    setFocus,
    setValue,
    setError,
    formState: { errors },
  } = useForm({
    mode: 'all',
    resolver: resSettings,
  })

  useInit({
    pageSizes,
    setDataLoaded,
    setShowOverlay,
    setDefaultPageSizeObj,
    setPageSizesObj,
    setValue,
    currentCustomer
  })

  useFocusError({
    errors,
    setFocus,
  })

  const isAdmin: boolean = hasAnyRole([roles.admin, roles.superAdmin])

  return (
    <Layout
      footerContent={<Footer />}
      brandContent={getBrandContent()}
      showOverlay={showOverlay}
      showCardHeader={true}
      headerInsert={
        <>
          <HeaderFilterRoleSelect
            setShowOverlay={setShowOverlay}
            handleFilterRoleChanged={(filterRole) => setCurrentFilterRole(filterRole)}
          />
          {hasAnyRole([roles.superAdmin]) && (
            <HeaderCustomerSelect
              setShowOverlay={setShowOverlay}
              handleCustomerChanged={(customer) => setCurrentCustomer(customer)}
            />
          )}
        </>
      }
      actionInsert={
        isAdmin && (
          <Button
            disabled={!dataLoaded}
            type='submit'
            name='save'
            className='btn-round btn-primary'
            onClick={() => {
              if (submitRef.current != null) {
                submitRef.current.click()
              }
            }}
          >
            Save
          </Button>
        )
      }
      menuBottomInsert={hasAnyRole([roles.superAdmin]) ? <LayoutSwitcher store={store} /> : false}
    >
      <Form
        onSubmit={handleSubmit((data) =>
          prepareSubmitForm({
            submitForm,
            setError,
            data,
            setShowOverlay,
            name: 'Settings',
          }),
        )}
        id='main-form'
      >
        <InputWrapper label={'Records per Page'} name={'pageSize'} errors={errors}>
          <SelectWrapper
            name={'pageSize'}
            control={control}
            options={pageSizesObj}
            optionLabel='name'
            optionValue='id'
            defaultValue={defaultPageSizeObj}
            placeholder='Select Records per Page...'
          />
        </InputWrapper>
        <Button type='submit' name='save' ref={submitRef} className='d-none'></Button>
      </Form>
    </Layout>
  )
}

export default Settings
